import React from 'react';
import Cookies from 'js-cookie';
import {
	Card, Row, Col, Input, Button, Form, DatePicker,
	message, Typography, Tooltip, Table, Select, Spin,
} from 'antd';
import {
	SearchOutlined, PrinterOutlined, CopyOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import {
	initHandler, ajaxViewHandler, ajaxHandler, setConfig,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import '../../assets/laporan.css';

const { Text } = Typography;

const configClass = {
	title: 'Laporan Per Rekening',
	apiUrl: {
		data: 'laporan/api/penerimaan/perekening/',
		warna_plat: 'master/api/plat',
		jenis_kendaraan: 'master/api/jenis/kendaraan/',
		payment: 'master/api/payment/?include_deleted=true',
		upt: 'pegawai/api/upt/',
		kabupaten: 'master/api/kabupaten/',
	},
	pageUrl: { cetak: '/laporan/perekening' },
};

const config = new Config();

const NAVY     = '#0f2847';
const NAVY_MID = '#1a3a6b';

const fmt = (v) => `Rp ${v != null ? Number(v).toLocaleString('id') : '0'}`;
const rp  = (v) =>        v != null ? Number(v).toLocaleString('id') : '0';

class LapPerRekening extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.config = new Config();
		this.state = {
			loading: false,
			data:    null,
			err:     false,
			errMsg:  '',
			filter:  '',
			mulai_dari:    '',
			sampai_dengan: '',
			isMobile: window.innerWidth <= 768,

			loadingWarnaPlat:      false, listWarnaPlat:      [],
			loadingJenisKendaraan: false, listJenisKendaraan: [],
			loadingPayment:        false, listPayment:        [],
			loadingUpt:            false, listUpt:            [],
			loadingKabupaten:      false, listKabupaten:      [],
			kabupaten_id: '',
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.loadMasterList();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		this.initKabupatenFromCookie();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	// Kabupaten yang dipilih pegawai saat login (cookie _upt) - dipakai untuk
	// auto-isi + kunci form Kabupaten pada non-superadmin, sama seperti
	// LapPenggunaanNoticeRusak.jsx.
	initKabupatenFromCookie() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			const kabupatenId = parsed.kabupaten;
			if (!kabupatenId) return;
			this.setState({ kabupaten_id: kabupatenId });
			setTimeout(() => {
				if (this.formRef.current) {
					this.formRef.current.setFieldsValue({ kabupaten: kabupatenId });
				}
			}, 0);
			this.getMasterList({
				destination: { stateProgressName: 'loadingUpt', endPoint: configClass.apiUrl.upt + '?kabupaten=' + kabupatenId, stateDestination: 'listUpt' },
				nextDestination: null,
			});
		} catch (err) {
			console.warn('Cookie _upt tidak valid:', err);
		}
	}

	isKabupatenLocked() {
		try {
			const rawCookie = Cookies.get(this.config.get_cookie_name() + '_upt');
			if (!rawCookie) return false;
			const parsed = JSON.parse(decodeURIComponent(rawCookie));
			return Boolean(parsed.kabupaten && parsed.id);
		} catch (err) {
			return false;
		}
	}

	loadMasterList() {
		const rule = [
			{
				destination: { stateProgressName: 'loadingJenisKendaraan', endPoint: configClass.apiUrl.jenis_kendaraan, stateDestination: 'listJenisKendaraan' },
				nextDestination: { stateProgressName: 'loadingWarnaPlat', endPoint: configClass.apiUrl.warna_plat, stateDestination: 'listWarnaPlat', next: null },
			},
			{
				destination: { stateProgressName: 'loadingPayment', endPoint: configClass.apiUrl.payment, stateDestination: 'listPayment' },
				nextDestination: { stateProgressName: 'loadingUpt', endPoint: configClass.apiUrl.upt, stateDestination: 'listUpt', next: null },
			},
			{
				destination: { stateProgressName: 'loadingKabupaten', endPoint: configClass.apiUrl.kabupaten, stateDestination: 'listKabupaten' },
				nextDestination: null,
			},
		];
		rule.forEach((item, index) => this.getMasterList(item, index === rule.length - 1));
	}

	async getMasterList(rule, isFinal = false) {
		const { destination, nextDestination } = rule;
		this.setState({ [destination.stateProgressName]: true });
		this.props.ajaxViewHandler('get', destination.endPoint)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					const cur = this.state[destination.stateDestination];
					let newState;
					if (data.count != null) {
						newState = (!cur.length || destination.stateProgressName.includes('_searching'))
							? data
							: { count: data.count, next: data.next, previous: data.previous, results: [...cur.results, ...data.results] };
					} else if (data.results != null) {
						newState = data.results;
					} else {
						newState = Array.isArray(data) ? data : [data];
					}
					this.setState({ [destination.stateDestination]: newState });
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data master', duration: 2, key: 'toast' });
				this.setState({ [destination.stateProgressName]: false });
			});

		if (nextDestination) {
			this.getMasterList({ destination: { stateProgressName: nextDestination.stateProgressName, endPoint: nextDestination.endPoint, stateDestination: nextDestination.stateDestination }, nextDestination: nextDestination.next });
		}
	}

	generateSelect(stateName, url, key, value, keyDisplay = '') {
		if (this.state['loading' + stateName]) {
			return <Spin size="small" />;
		}
		const list = this.state['list' + stateName];
		const items = list.count != null ? list.results : (Array.isArray(list) ? list : []);
		return (
			<Select
				showSearch allowClear size="small"
				placeholder={'Pilih ' + stateName}
				disabled={stateName === 'Kabupaten' && this.isKabupatenLocked()}
				optionFilterProp="children"
				style={{ width: '100%', borderRadius: 8 }}
				onSearch={(val) => {
					const sep = url.includes('?') ? '&' : '?';
					const endPoint = stateName === 'Upt'
						? `${url}${sep}kabupaten=${this.state.kabupaten_id}&search=${val}`
						: `${url}${sep}search=${val}`;
					this.getMasterList({ destination: { stateProgressName: 'loading' + stateName + '_searching', endPoint, stateDestination: 'list' + stateName }, nextDestination: null });
				}}
				onPopupScroll={(e) => {
					e.persist();
					const t = e.target;
					if (t.scrollTop + t.offsetHeight >= t.scrollHeight && list.next) {
						this.getMasterList({ destination: { stateProgressName: 'loading' + stateName + 'Paging', endPoint: list.next, stateDestination: 'list' + stateName }, nextDestination: null });
					}
				}}
				onChange={(val) => {
					if (stateName === 'Kabupaten') {
						this.setState({ kabupaten_id: val }, () => {
							this.getMasterList({ destination: { stateProgressName: 'loadingUpt', endPoint: configClass.apiUrl.upt + '?kabupaten=' + val, stateDestination: 'listUpt' }, nextDestination: null });
						});
					}
				}}
			>
				{this.state['loading' + stateName + '_searching'] && <Select.Option value=""><Spin size="small" /></Select.Option>}
				{items.map((item) => (
					<Select.Option key={item[key]} value={item[key]}>
						{keyDisplay ? item[keyDisplay] + ' - ' + item[value] : item[key] + ' - ' + item[value]}
					</Select.Option>
				))}
				{list.next && <Select.Option value=""><Spin size="small" /></Select.Option>}
			</Select>
		);
	}

	handleSubmit = (values) => {
		const parts = [];
		for (const key in values) {
			if (values[key] != null) parts.push(`${key}=${values[key]}`);
		}
		const filter = parts.length ? '?' + parts.join('&') : '';
		this.setState({ filter });
		this.getData(filter);
	};

	async getData(filter) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({ loading: true, err: false, data: null });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + filter)
			.then(() => {
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({ loading: false, data: this.props.responseMsg, err: false });
				} else {
					this.setState({ loading: false, data: null, err: true, errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat laporan', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				this.setState({ loading: false, data: null, err: true });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	_kpiCard({ icon, label, value, accent }) {
		return (
			<div style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', border: `1px solid ${accent}22`, boxShadow: `0 2px 12px ${accent}14`, display: 'flex', flexDirection: 'column', gap: 6, flex: '1 1 150px', minWidth: 0 }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
					<div style={{ width: 32, height: 32, borderRadius: 9, background: `${accent}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, flexShrink: 0 }}>{icon}</div>
					<span style={{ fontSize: 10, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .8 }}>{label}</span>
				</div>
				<div style={{ fontSize: 16, fontWeight: 900, color: accent, fontFamily: 'monospace', lineHeight: 1.1 }}>{value}</div>
			</div>
		);
	}

	render() {
		const { loading, data, err, filter, mulai_dari, sampai_dengan, isMobile } = this.state;

		const d = data?.data || [];
		const header = data?.header;

		const totalBbnkb1  = d.reduce((s, i) => s + (i.jenis_kendaraan.bbnkb.pokok    + i.jenis_kendaraan.bbnkb.denda),    0);
		const totalBbnkb2  = d.reduce((s, i) => s + (i.jenis_kendaraan.bbnkb_ii.pokok + i.jenis_kendaraan.bbnkb_ii.denda), 0);
		const totalPkb     = d.reduce((s, i) => s + (i.jenis_kendaraan.pkb.pokok      + i.jenis_kendaraan.pkb.denda),      0);
		const grandTotal   = d.reduce((s, i) => s +  i.jenis_kendaraan.total,                                              0);

		const columns = [
			{ title: 'Kode',             width: 70,  align: 'center',
				render: (_, row) => <Text style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 12, color: NAVY }}>{row.jenis_kendaraan.kode}</Text> },
			{ title: 'Jenis Kendaraan',
				render: (_, row) => <Text style={{ fontSize: 12, fontWeight: 600 }}>{row.jenis_kendaraan.nama}</Text> },
			{ title: 'BBN I Pokok',      width: 120, align: 'right',
				render: (_, row) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: '#1d4ed8', fontWeight: 600 }}>{rp(row.jenis_kendaraan.bbnkb.pokok)}</Text> },
			{ title: 'BBN I Denda',      width: 110, align: 'right',
				render: (_, row) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: row.jenis_kendaraan.bbnkb.denda > 0 ? '#cf1322' : '#cbd5e1', fontWeight: 600 }}>{rp(row.jenis_kendaraan.bbnkb.denda)}</Text> },
			{ title: 'BBN II Pokok',     width: 120, align: 'right',
				render: (_, row) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: '#7c3aed', fontWeight: 600 }}>{rp(row.jenis_kendaraan.bbnkb_ii.pokok)}</Text> },
			{ title: 'BBN II Denda',     width: 110, align: 'right',
				render: (_, row) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: row.jenis_kendaraan.bbnkb_ii.denda > 0 ? '#cf1322' : '#cbd5e1', fontWeight: 600 }}>{rp(row.jenis_kendaraan.bbnkb_ii.denda)}</Text> },
			{ title: 'PKB Pokok',        width: 120, align: 'right',
				render: (_, row) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: '#047857', fontWeight: 600 }}>{rp(row.jenis_kendaraan.pkb.pokok)}</Text> },
			{ title: 'PKB Denda',        width: 110, align: 'right',
				render: (_, row) => <Text style={{ fontFamily: 'monospace', fontSize: 12, color: row.jenis_kendaraan.pkb.denda > 0 ? '#cf1322' : '#cbd5e1', fontWeight: 600 }}>{rp(row.jenis_kendaraan.pkb.denda)}</Text> },
			{ title: 'Total',            width: 140, align: 'right',
				render: (_, row) => <Text style={{ fontFamily: 'monospace', fontSize: 13, fontWeight: 800, color: NAVY }}>{rp(row.jenis_kendaraan.total)}</Text> },
		];

		const labelFilter = (txt) => (
			<span style={{ fontSize: 11, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: .5 }}>{txt}</span>
		);

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.rek-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 11px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.rek-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.rek-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.rek-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.rek-wrap .ant-form-item-label > label { font-weight: 600; color: #475569; font-size: 11px; }
						.rek-wrap .ant-picker, .rek-wrap .ant-input, .rek-wrap .ant-select-selector { border-radius: 8px !important; }
					`}</style>
				</Helmet>

				<div className="rek-wrap">
					<Row gutter={[0, 16]}>

						{/* ══ FILTER PANEL ══ */}
						<Col span={24}>
							<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(15,40,71,0.07)' }}>

								{/* Header dark navy */}
								<div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
									<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
										<div style={{ width: 38, height: 38, background: 'rgba(251,191,36,0.15)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 19 }}>📊</div>
										<div>
											<div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>{configClass.title}</div>
											<div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>Laporan harian bendaharawan khusus penerimaan pajak BBNKB dan PKB</div>
										</div>
									</div>
									{data && (
										<Tooltip title="Cetak laporan">
											<a href={configClass.pageUrl.cetak + filter} target="_blank" rel="noopener noreferrer">
												<Button icon={<PrinterOutlined />} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)', color: '#fff', fontWeight: 600 }}>
													{!isMobile && 'Cetak'}
												</Button>
											</a>
										</Tooltip>
									)}
								</div>

								{/* Filter form */}
								<Form layout="vertical" name="fdata" ref={this.formRef} onFinish={this.handleSubmit} size="small" disabled={loading} style={{ padding: '18px 20px 14px' }}>
									<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '0 16px' }}>

										<Form.Item name="kabupaten" label={labelFilter('Kabupaten')} style={{ marginBottom: 10 }}>
											{this.generateSelect('Kabupaten', configClass.apiUrl.kabupaten, 'id', 'name')}
										</Form.Item>

										<Form.Item name="upt" label={labelFilter('UPT')} style={{ marginBottom: 10 }}>
											{this.generateSelect('Upt', configClass.apiUrl.upt, 'id', 'nama', 'id')}
										</Form.Item>

										<Form.Item name="jenis_kendaraan" label={labelFilter('Jenis Kendaraan')} style={{ marginBottom: 10 }}>
											{this.generateSelect('JenisKendaraan', configClass.apiUrl.jenis_kendaraan, 'id', 'nama', 'kode')}
										</Form.Item>

										<Form.Item name="warna_plat" label={labelFilter('Warna Plat')} style={{ marginBottom: 10 }}>
											{this.generateSelect('WarnaPlat', configClass.apiUrl.warna_plat, 'id', 'nama', 'kode')}
										</Form.Item>

										<Form.Item name="roda" label={labelFilter('Jumlah Roda')} style={{ marginBottom: 10 }}>
											<Input placeholder="cth: 2" size="small" style={{ borderRadius: 8 }} />
										</Form.Item>

										<Form.Item name="payment_type" label={labelFilter('Jenis Pembayaran')} style={{ marginBottom: 10 }}>
											{this.generateSelect('Payment', configClass.apiUrl.payment, 'id', 'nama', 'kode')}
										</Form.Item>

										<Form.Item name="mulai_dari_picker" label={labelFilter('Periode Mulai')} style={{ marginBottom: 10 }}>
											<DatePicker placeholder="dd-mm-yyyy" format="DD-MM-YYYY" style={{ width: '100%', borderRadius: 8 }}
												onChange={(_, s) => { this.formRef.current.setFieldsValue({ mulai_dari: s }); this.setState({ mulai_dari: s }); }}
											/>
										</Form.Item>

										<Form.Item name="sampai_dengan_picker" label={labelFilter('Sampai Dengan')} style={{ marginBottom: 10 }}>
											<DatePicker placeholder="dd-mm-yyyy" format="DD-MM-YYYY" style={{ width: '100%', borderRadius: 8 }}
												onChange={(_, s) => { this.formRef.current.setFieldsValue({ sampai_dengan: s }); this.setState({ sampai_dengan: s }); }}
											/>
										</Form.Item>
									</div>

									{/* Hidden fields */}
									<Form.Item name="mulai_dari"    style={{ display: 'none' }}><Input type="hidden" /></Form.Item>
									<Form.Item name="sampai_dengan" style={{ display: 'none' }}><Input type="hidden" /></Form.Item>

									{/* Buttons */}
									<div style={{ display: 'flex', gap: 10, paddingTop: 4 }}>
										<Button loading={loading} type="primary" htmlType="submit" disabled={loading} icon={!loading && <SearchOutlined />}
											style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 700, background: NAVY, borderColor: NAVY }}>
											Proses Laporan
										</Button>
										{data && (
											<a href={configClass.pageUrl.cetak + filter} target="_blank" rel="noopener noreferrer">
												<Button icon={<PrinterOutlined />} style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 600 }}>
													Cetak
												</Button>
											</a>
										)}
									</div>
								</Form>
							</div>
						</Col>

						{/* ══ LOADING ══ */}
						{loading && (
							<Col span={24}>
								<div style={{ background: '#fff', borderRadius: 14, padding: '36px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
									<Spin size="large" />
									<div style={{ marginTop: 12, color: '#64748b', fontSize: 13 }}>Memproses laporan, mohon tunggu...</div>
								</div>
							</Col>
						)}

						{/* ══ EMPTY ══ */}
						{!data && !loading && !err && (
							<Col span={24}>
								<div style={{ background: '#fff', borderRadius: 14, padding: '48px 24px', textAlign: 'center', border: '1px solid #e2e8f0', color: '#aaa' }}>
									<div style={{ fontSize: 36, marginBottom: 12 }}>📊</div>
									<div style={{ fontSize: 14 }}>Isi filter dan tekan <b>Proses Laporan</b> untuk menampilkan data</div>
								</div>
							</Col>
						)}

						{/* ══ ERROR ══ */}
						{err && !loading && (
							<Col span={24}>
								<div style={{ background: '#fff1f0', borderRadius: 14, padding: '36px 24px', textAlign: 'center', border: '1px solid #ffa39e', color: '#cf1322' }}>
									<div style={{ fontSize: 14, fontWeight: 600 }}>Gagal memuat laporan. Coba kembali.</div>
								</div>
							</Col>
						)}

						{/* ══ HASIL ══ */}
						{data && !loading && (
							<>
								{/* Info bar */}
								<Col span={24}>
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
										<div>
											<div style={{ fontSize: 15, fontWeight: 700, color: NAVY }}>Laporan Per Rekening — BBN & PKB</div>
											<div style={{ fontSize: 12, color: '#64748b' }}>
												{header?.uptppd && <span>UPTD: <b>{header.uptppd}</b> &nbsp;·&nbsp; </span>}
												Periode: <b>{header?.mulai_dari === header?.sampai_dengan ? header?.mulai_dari : `${header?.mulai_dari} s/d ${header?.sampai_dengan}`}</b>
											</div>
										</div>
									</div>
								</Col>

								{/* KPI Cards */}
								<Col span={24}>
									<div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
										<div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, borderRadius: 14, padding: '18px 22px', flex: '1 1 180px', minWidth: 0, boxShadow: '0 4px 18px rgba(15,40,71,0.2)' }}>
											<div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>💰 GRAND TOTAL</div>
											<div style={{ fontSize: 20, fontWeight: 900, color: '#fbbf24', fontFamily: 'monospace', lineHeight: 1 }}>{fmt(grandTotal)}</div>
											<div style={{ fontSize: 10, color: '#64748b', marginTop: 6 }}>{d.length} jenis kendaraan</div>
										</div>
										{this._kpiCard({ icon: '🔵', label: 'Total BBN KB I',  value: fmt(totalBbnkb1), accent: '#1d4ed8' })}
										{this._kpiCard({ icon: '🟣', label: 'Total BBN KB II', value: fmt(totalBbnkb2), accent: '#7c3aed' })}
										{this._kpiCard({ icon: '🟢', label: 'Total PKB',       value: fmt(totalPkb),    accent: '#047857' })}
									</div>
								</Col>

								{/* Tabel Data */}
								<Col span={24}>
									<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(15,40,71,0.06)' }}>
										<div style={{ background: '#0f284708', padding: '12px 18px', display: 'flex', alignItems: 'center', gap: 8, borderBottom: '1px solid #0f284722' }}>
											<span style={{ fontSize: 16 }}>📋</span>
											<span style={{ fontSize: 13, fontWeight: 700, color: NAVY, flex: 1, textTransform: 'uppercase', letterSpacing: .8 }}>Rincian Per Jenis Kendaraan</span>
											<span style={{ fontSize: 12, color: '#64748b' }}>{d.length} jenis</span>
										</div>
										<div style={{ overflowX: 'auto' }}>
											<Table
												columns={columns}
												dataSource={d}
												rowKey={(_, i) => i}
												size="small"
												pagination={false}
												style={{ minWidth: 900 }}
												summary={() => (
													<Table.Summary.Row style={{ background: `${NAVY}0a`, fontWeight: 700 }}>
														<Table.Summary.Cell colSpan={2}>
															<Text style={{ fontSize: 12, fontWeight: 700, color: NAVY }}>TOTAL KESELURUHAN</Text>
														</Table.Summary.Cell>
														<Table.Summary.Cell align="right">
															<Text style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 12, color: '#1d4ed8' }}>{rp(totalBbnkb1)}</Text>
														</Table.Summary.Cell>
														<Table.Summary.Cell />
														<Table.Summary.Cell align="right">
															<Text style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 12, color: '#7c3aed' }}>{rp(totalBbnkb2)}</Text>
														</Table.Summary.Cell>
														<Table.Summary.Cell />
														<Table.Summary.Cell align="right">
															<Text style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 12, color: '#047857' }}>{rp(totalPkb)}</Text>
														</Table.Summary.Cell>
														<Table.Summary.Cell />
														<Table.Summary.Cell align="right">
															<Text style={{ fontFamily: 'monospace', fontWeight: 800, fontSize: 13, color: NAVY }}>{rp(grandTotal)}</Text>
														</Table.Summary.Cell>
													</Table.Summary.Row>
												)}
											/>
										</div>
									</div>
								</Col>

								{/* Grand Total Bar */}
								<Col span={24}>
									<div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, borderRadius: 14, padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, boxShadow: '0 4px 20px rgba(15,40,71,0.2)' }}>
										<div>
											<div style={{ fontSize: 11, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>TOTAL SELURUH PENERIMAAN</div>
											<div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
												{[{ label: 'BBN KB I', val: totalBbnkb1 }, { label: 'BBN KB II', val: totalBbnkb2 }, { label: 'PKB', val: totalPkb }].map((s, i) => (
													<div key={i} style={{ fontSize: 11, color: '#94a3b8' }}>{s.label}: <span style={{ color: '#cbd5e1', fontWeight: 600 }}>{fmt(s.val)}</span></div>
												))}
											</div>
										</div>
										<div style={{ fontSize: 26, fontWeight: 900, color: '#fbbf24', fontFamily: 'monospace' }}>{fmt(grandTotal)}</div>
									</div>
								</Col>

								{/* Tanda Tangan */}
								{data.ttd && (
									<Col span={24}>
										<div style={{ background: '#fff', borderRadius: 14, padding: '20px 24px', border: '1px solid #e2e8f0' }}>
											<Row justify="space-between">
												{data.ttd.kiri && (
													<Col span={10} style={{ textAlign: 'center' }}>
														<div style={{ fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 4 }}>MENGETAHUI</div>
														<div style={{ fontSize: 12, color: '#64748b' }}>{data.ttd.kiri.jabatan}</div>
														<div style={{ marginTop: 52, paddingTop: 8, borderTop: '1px solid #e2e8f0' }}>
															<div style={{ fontSize: 13, fontWeight: 700, color: NAVY }}><u>{data.ttd.kiri.nama}</u></div>
															<div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>NIP : {data.ttd.kiri.nip}</div>
														</div>
													</Col>
												)}
												{data.ttd.kanan && (
													<Col span={10} style={{ textAlign: 'center' }}>
														<div style={{ fontSize: 12, color: '#64748b' }}>{header?.uptppd || ''}, {moment().format('DD-MM-YYYY')}</div>
														<div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>{data.ttd.kanan.jabatan}</div>
														<div style={{ marginTop: 52, paddingTop: 8, borderTop: '1px solid #e2e8f0' }}>
															<div style={{ fontSize: 13, fontWeight: 700, color: NAVY }}><u>{data.ttd.kanan.nama}</u></div>
															<div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>NIP : {data.ttd.kanan.nip}</div>
														</div>
													</Col>
												)}
											</Row>
										</div>
									</Col>
								)}
							</>
						)}
					</Row>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(LapPerRekening);
